import React, { Children } from 'react';
import { motion } from 'framer-motion';
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.06
    }
  }
};
const logoVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
const founders = [{
  name: 'Emmett Shear',
  url: 'https://softmax.com/team'
}, {
  name: 'John Andrew Entwistle',
  url: 'https://www.wander.com/about'
}, {
  name: 'Max Hodak',
  url: 'https://techcrunch.com/2025/12/05/after-neuralink-max-hodak-is-building-something-stranger/'
}, {
  name: 'Divya Aathresh',
  url: null
}, {
  name: 'Dan Kan',
  url: 'https://share.google/E7p4ih7fRzErEt9DH'
}, {
  name: 'Martin Hunt',
  url: 'https://techcrunch.com/2025/08/20/yc-backed-garage-raises-13-5m-to-help-firefighters-buy-equipment/'
}, {
  name: 'Harry Gestetner',
  url: 'https://www.forbes.com/sites/alexyork/2025/11/14/this-under-30-raised-18-million-to-make-sleeping-cool-literally/'
}, {
  name: 'Casey Winters',
  url: 'https://www.superme.ai/casey'
}, {
  name: 'Joe Lubin',
  url: 'https://share.google/Nid4f4uWcgnp5UnkV'
}];
export function PortfolioSection() {
  return <section id="portfolio" className="py-32 px-6 md:px-12 border-t border-white/5" data-id="element-48">
      <div className="max-w-7xl mx-auto" data-id="element-49">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} className="mb-16" data-id="element-50">
          <h2 className="font-serif text-4xl md:text-5xl text-text-primary mb-4" data-id="element-51">
            Portfolio
          </h2>
          <p className="font-sans font-light text-text-muted text-base md:text-lg" data-id="element-52">
            A growing group of N of 1 builders
          </p>
        </motion.div>

        {/* Founder grid */}
        <motion.div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-0" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-60px'
      }} data-id="element-53">
          {founders.map(founder => {
          const lastSpace = founder.name.lastIndexOf(' ');
          const firstName = founder.name.slice(0, lastSpace);
          const lastName = founder.name.slice(lastSpace + 1);
          const content = <span className="flex flex-col items-center text-center font-sans font-medium text-sm tracking-wide" data-id="element-54">
                <span data-id="element-55">{firstName}</span>
                <span data-id="element-56">{lastName}</span>
              </span>;
          return <motion.div key={founder.name} variants={logoVariants} className="flex items-center justify-center py-8 px-4 border-b border-white/5 group" data-id="element-57">
                {founder.url ? <a href={founder.url} target="_blank" rel="noopener noreferrer" className="text-text-muted hover:text-accent transition-colors duration-300" data-id="element-58">
                    {content}
                  </a> : <span className="text-text-muted" data-id="element-59">{content}</span>}
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}